import { Instance, types } from 'mobx-state-tree';

export enum AlertTypes {
    success = 'success',
    warning = 'warning',
    error = 'error',
    info = 'info',
}

const AlertModel = types.model('AlertModel', {
    id: types.string,
    type: types.enumeration('Type', Object.values(AlertTypes)),
    title: types.string,
    description: types.string,
});

export type IAlertModel = Instance<typeof AlertModel>;

export default AlertModel;
